<template>
    <div class="bg_box">
      <div class="box">
        <div style="height: 20px"></div>
        <div class="aside_box">
          <el-input
            placeholder="请输入内容"  v-model="searchFormData.keyword"  class="input-with-select"
          >
            <el-select v-model="selects" slot="prepend" placeholder="请选择">
              <el-option label="搜索职位" value="1"></el-option>
              <el-option label="搜索企业" value="2"></el-option>
              <el-option label="搜索社团" value="3"></el-option>
            </el-select>
            <el-button slot="append" @click="serach">搜索</el-button>
          </el-input>
          <div class="hotbox">
            <div class="leftbox">热门搜索：</div>
            <div class="rightbox" v-for="(item, index) in hotlist" :key="index">
              <div>{{ item }}</div>
            </div>
          </div>
          <div class="linebox"></div>
          <div class="classify">
            <div>
              <el-select v-model="searchFormData.education" placeholder="学历要求">
                <el-option
                  v-for="item in educationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="searchFormData.work_nature"
                placeholder="工作性质"
                style="margin: 0 40px"
              >
                <el-option
                  v-for="item in option2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              
              <el-select v-model="searchFormData.job_seeker_status" placeholder="求职身份">
                <el-option
                  v-for="item in option3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div @click="clear">清空搜索条件</div>
          </div>
        </div>

        <div class="content_box">
          <div class="sort_box">
            <div class="sort_boxchild">
              <span>薪资</span>
              <img
                v-show="flag1 == false"
                @click="sort()"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag1 == true"
                @click="resever()"
                src="@/assets/image/sort.png"
              />
            </div>
            <div class="sort_boxchild">
              <span v-show="flag2 == false">浏览量</span>
              <span v-show="flag2">浏览量</span>
              <img
                @click="sorts()"
                v-show="flag2 == false"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag2"
                @click="resevers()"
                src="@/assets/image/sort.png"
              />
            </div>
          </div>
          <div class="line_box"></div>

          <div class="hei_box">
            <div class="list_box">
              <div class="list_box_childs" ref="scroll">
                <div
                  class="list_box_childs_s"
                  v-for="(item, index) in list2"
                  :key="index"
                  @click="jobdetail(item.job_id)"
                >
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag" style="padding-bottom: 10px">
                      <div>
                        {{ item.alias_name }}&emsp;<span
                          style="color: #999999"
                          >{{ item.created_at }}</span
                        >发布
                      </div>
                      <div>浏览量：{{ item.views }}</div>
                      <div>
                        距离：<span style="color: #7893db">{{ item.km }}</span>
                      </div>
                    </div>
                    <div class="list_flags">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div class="list_flag_child">
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <div class="list_flag_text">
                            {{ item.title }}
                          </div>
                          <div style="color: #7893db">[兼职]</div>
                          <img
                            style="width: 20px; height: 20px"
                            src="/img/火爆.png"
                          />
                          <div style="font-weight: bold; color: red">
                            {{ item.wages_max }}-{{ item.wages_min
                            }}{{ item.unit }}
                          </div>
                        </div>
                        <div>
                          <span style="padding-right: 20px"
                            >工作时间：{{ item.work_time }}</span
                          >
                          <span v-show="item.sex == 0">男女不限</span>
                          <span v-show="item.sex == 1">男</span>
                          <span v-show="item.sex == 2">女</span>
                          <span style="padding-left: 20px">{{
                            item.education_str
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list_flag_bottom">
                      <div>截止日期：剩余{{ item.count_down }}</div>
                      <div>
                        空余岗位：（<span style="color: red">{{
                          item.surplus_number
                        }}</span
                        >）个
                      </div>
                    </div>
                    <div class="list_flag_bottoms">
                      <div class="list_flag_bottom_child">五险一金</div>
                      <div class="list_flag_bottom_child">五险一金</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
</template>

<script>
import { recommendsearch } from "@/api/director/talent/index";
import { searchlist } from "@/api/personal/job/index";
export default {
  data() {
    return {
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6: false,
      input1: "1",
      input2: "",
      input3: "",
      searchFormData:{
        keyword:"",
        education:"",
        work_nature:"",
        job_seeker_status:"",
      },
      selects: "请选择",
      educationOptions: [
        {
          value: "0",
          label: "不限",
        },
        {
          value: "1",
          label: "初中及以下",
        },
        {
          value: "2",
          label: "高中及以上",
        },
        {
          value: "3",
          label: "大专及以上",
        },
        {
          value: "4",
          label: "本科及以上",
        },
        {
          value: "5",
          label: "研究生及以上",
        },
       
      ],
      option2: [
        {
          value: "1",
          label: "全职",
        },
        {
          value: "2",
          label: "兼职",
        },
        
      ],
      option3: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "职场人",
        },
        {
          value: "3",
          label: "学生/应届",
        },
        {
          value: "4",
          label: "学生在校",
        },
      ],
      list1: [],
      list2: [],
      value1: "",
      value2: "",
      value3: "",
      hotlist: [
        "家政",
        "出纳",
        "人才资源经理",
        "机械工程师",
        "审计",
        "清洁工",
        "普工",
        "叉车司机",
        "塔吊司机",
      ],
      isLoad: true,
      msg: "正在加载",
      commid: "",
      usertype: "",
      lat: "",
      lng: "",
    };
  },
  created() {
    this.usertype = localStorage.getItem("user_type") == 2 ? 2 : 1;
    this.commid = this.$route.query.id;
    this.getlist();
    this.getjoblist();
  },
  mounted() {
    this.getLocation();
    //开启滚动事件
    // window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    //关闭滚动事件
    // window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    //定位当前位置
    getLocation() {
      if (typeof window.qq === 'undefined' || !window.qq.maps) {
        return;
      }
      var geolocation = new window.qq.maps.Geolocation(
        "EYFBZ-4BKW6-HYVS7-EEFUP-QRAH5-7LBBX",
        "referer-jianzhibei"
      );
      geolocation.getLocation(this.showPosition, this.errorPosition);
    },
    showPosition(position) {
      console.log(position, "sssssssssss");
      let data = {
        lat: position.lat,
        lng: position.lng,
      };
      searchlist(data).then((res) => {
        this.list2 = res.data.data;
      });
    },
    errorPosition() {
      console.log("定位失败");
      //继续定位
      this.getLocation();
    },
    paixu1() {
      this.flag3 = true;
      let data = {
        keyword: this.input3,
        order: "salaryStr",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai1() {
      this.flag3 = false;
      let data = {
        keyword: this.input3,
        order: "salaryStr",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu2() {
      this.flag4 = true;
      let data = {
        keyword: this.input3,
        order: "credit",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai2() {
      this.flag4 = false;
      let data = {
        keyword: this.input3,
        order: "credit",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu3() {
      this.flag5 = true;
      let data = {
        keyword: this.input3,
        order: "fans",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai3() {
      this.flag5 = false;
      let data = {
        keyword: this.input3,
        order: "fans",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu4() {
      this.flag6 = true;
      let data = {
        keyword: this.input3,
        order: "popularity",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai4() {
      this.flag6 = false;
      let data = {
        keyword: this.input3,
        order: "popularity",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    //正序
    sort() {
      this.flag1 = true;
      let data = {
        keyword: this.input3,
        order: "wages_min",
        orderBy: "ASC",
      };
      searchlist(data).then((res) => {
        this.list2 = res.data.data;
      });
    },
    //倒序
    resever() {
      this.flag1 = false;
      let data = {
        keyword: this.input3,
        order: "wages_min",
        orderBy: "DESC",
      };
      searchlist(data).then((res) => {
        this.list2 = res.data.data;
      });
    },
    //浏览量正序
    sorts() {
      this.flag2 = true;
      let data = {
        keyword: this.input3,
        order: "views",
        orderBy: "ASC",
      };
      searchlist(data).then((res) => {
        this.list2 = res.data.data;
      });
    },
    //浏览量倒序
    resevers() {
      this.flag2 = false;
      let data = {
        keyword: this.input3,
        order: "views",
        orderBy: "DESC",
      };
      searchlist(data).then((res) => {
        this.list2 = res.data.data;
      });
    },
    clear() {
      this.input3 = "";
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
    },
    jobdetail(id) {
      this.$router.push({ name: "position-detail", query: { id: id } });
    },
    detail(id) {
      this.$router.push({ name: "personal-homepage", query: { id: id } });
    },
    getjoblist() {
      searchlist().then((res) => {
        this.list2 = res.data.data;
      });
    },
    //搜索事件
    serach() {
      if (this.usertype == 1) {
        let data = {
          keyword: this.input3,
        };
        searchlist(data).then((res) => {
          this.list2 = res.data.data;
        });
      }

      if (this.usertype == 2) {
        let data = {
          keyword: this.input3,
        };
        recommendsearch(data).then((res) => {
          this.list1 = res.data.data;
        });
      }
    },
    getlist() {
      recommendsearch().then((res) => {
        this.list1 = res.data.data;
      });
    },
    onScroll() {
      //可滚动容器的高度
      let innerHeight = this.$refs.scroll.clientHeight;
      //屏幕尺寸高度
      let outerHeight = document.documentElement.clientHeight;
      //可滚动容器超出当前窗口显示范围的高度
      let scrollTop = document.documentElement.scrollTop;
      //避免切换时读取到异常高度
      if (scrollTop == 0) {
        innerHeight = 10000;
      }
      //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
      console.log(innerHeight + " " + outerHeight + " " + scrollTop);
      if (this.isLoad) {
        if (innerHeight <= outerHeight + scrollTop) {
          //此处添加自定义操作
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select .el-input__inner {
  border: none;
}

.bg_box {
  background-color: #eeeeee;
  .box {
    width: 1200px;
    margin: auto;

    .content_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      .content_child {
        width: 95%;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: auto;
      }
      .sort_box {
        padding-top: 20px;
        width: 95%;
        padding-bottom: 30px;
        margin: auto;
        display: flex;
        align-items: center;
        .sort_boxchild {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 30px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
      .line_box {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 5px;
      }
      .hei_box {
        height: 600px;
      }
      .list_box {
        width: 95%;
        height: 100%;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: auto;
        .list_box_childs {
          width: 100%;
          height: 100%;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          overflow-y: scroll;
          .list_box_childs_s:hover {
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          }
          .list_box_childs_s {
            font-size: 12px;
            width: 48.5%;
            border: 1px solid #c8c8c8;
            border-radius: 8px;
            margin-right: 10px;
            margin-bottom: 10px;
            height: 143px;
            .sty {
              padding: 0 30px;
            }
            .list_flag_bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 5px;
            }
            .list_flag_bottoms {
              display: flex;
              align-items: center;
              padding-top: 5px;
              .list_flag_bottom_child {
                padding: 2px 5px;
                border: 1px solid #999999;
                margin-right: 10px;
                border-radius: 5px;
              }
            }
            .list_flags {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .list_flag_child {
                .list_flag_text {
                  font-weight: bold;
                  font-size: 16px;
                  width: 150px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                width: 88%;
                height: 50px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: left;
              }
            }
            .list_flag {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .btn {
                width: 80px;
                height: 30px;
                border-radius: 8px;
                background-color: #4a72dd;
                color: white;
                text-align: center;
                line-height: 30px;
              }
            }
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
          }
        }
      }
    }

    .aside_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      // margin-top: 20px;
      margin-bottom: 30px;
      padding: 20px;
      .classify {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .linebox {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 20px;
      }
      .hotbox {
        margin: 20px 0;
        display: flex;
        align-items: center;
        .leftbox {
          padding-right: 20px;
        }
        .rightbox {
          color: #4c71db;
          display: flex;
          align-items: center;
          div {
            padding: 0 20px;
          }
        }
      }
    }
  }
}
</style>
